import { React, useState, useCallback, observer, useTranslation, main } from '../..';
import { Form, SelectHierarchy } from '@weezevent/nacre';
import useDateFormat from '../../../../../components/utils/useDateFormat';
import { useMemo } from 'react';
const SessionsSelect = observer(() => {
    const { t } = useTranslation();
    const { sessions, isLoadingSessions } = main;
    let { selectedSessions } = main;
    const [selected, setSelected] = useState(selectedSessions);

    const session = useCallback(
        date => {
            const [properDate, properTime] = useDateFormat({
                date,
                event: main?.event,
                dateStyle: 'short',
                timeStyle: 'short'
            });
            return `${properDate} - ${properTime}`;
        },
        [sessions, selectedSessions]
    );

    const handleChange = useCallback(
        (selected, selectedOption) => {
            setSelected(selected);
            main.setSelectedSessions(selected, selectedOption);
        },
        [selected, selectedSessions]
    );

    const options = useMemo(() => {
        const list = Object.values(sessions).map(option => ({ text: session(option.text), value: option.value, weez_date_id: option.weez_date_id, object: option.object }));

        if (Object.values(sessions)?.length === 1) {
            setSelected(list[0].value);
            main.setSelectedSessions(list[0].value);
        }
        return list;
    }, [sessions]);

    return (
        <Form.Field>
            <Form.Label label={t('ticket.common.seances')} />

            <SelectHierarchy
                placeholder={t('ticket.common.action.select')}
                placeholderSearch={t('ticket.common.action.search')}
                depth={0}
                height="maxi"
                value={selected}
                onChange={(e, option) => handleChange(e, option)}
                options={options}
                multi={false}
                loading={isLoadingSessions}
                disabled={isLoadingSessions}
            />
        </Form.Field>
    );
});
export default SessionsSelect;
